import type { RouterConfig } from "@nuxt/schema";
// https://router.vuejs.org/api/interfaces/routeroptions.html
export default <RouterConfig>{
	async scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		}

		const findEl = (hash: string) => {
			return (
				document.querySelector(hash) ||
				new Promise((resolve) => {
					setTimeout(() => {
						resolve(findEl(hash));
					}, 100);
				})
			);
		};

		if (to.hash) {
			const el: any = await findEl(to.hash);

			if ("scrollBehavior" in document.documentElement.style) {
				return window.scrollTo({ top: el.offsetTop, behavior: "smooth" });
			} else {
				return window.scrollTo(0, el.offsetTop);
			}
		}

		if (from.path === to.path) {
			return savedPosition;
		} else {
			return { left: 0, top: 0, behaviour: "smooth" };
		}
	},
	routes: routes => [
		...routes,
		{
			name: "shop-kind-product",
			path: "/shop/:kind/:product",
			component: () => import("~/pages/shop/[kind]/[product].vue")
		}
	]
};
